<script>
    import Card from './Card.svelte';

    export let entries;
</script>

<div class="w-full lg:container lg:mx-auto">
    <div class="lg:flex lg:justify-center">
        {#each entries.storageSolutionsImageCard as card, i}
            <Card originalImage={card.imageCardAsset[0].url} imageData={card.imageCardAsset[0].storageSolutionsOptimizedImages} content={card.imageCardContent} index={i} />
        {/each}
    </div>
</div>